import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getTemplates, type DesignAsset } from 'src/api/designPlatform';

type UseDesignPlatformTemplatesOptions = Pick<UseQueryOptions<DesignAsset[]>, 'enabled'>;

export const useDesignPlatformTemplates = (addonId: string | null, options: UseDesignPlatformTemplatesOptions = {}) => {
  const { enabled = true } = options;

  return useQuery<DesignAsset[]>({
    queryKey: ['design-platform-templates', addonId],
    queryFn: () => {
      if (!addonId) {
        throw new Error('addonId is required');
      }
      return getTemplates(addonId);
    },
    enabled: !!addonId && enabled,
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
};
